import * as React from 'react';

const TelegramIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M2.955 14.537c8-3.474 13.326-5.783 16-6.903 7.611-3.177 9.211-3.725 10.24-3.748.229 0 .731.045 1.074.32.275.228.343.525.389.754s.091.709.046 1.074c-.412 4.343-2.195 14.88-3.109 19.726-.389 2.057-1.143 2.743-1.874 2.811-1.6.138-2.812-1.051-4.343-2.057-2.423-1.577-3.772-2.56-6.126-4.114-2.72-1.783-.96-2.766.594-4.366.412-.411 7.429-6.811 7.566-7.382.023-.07.023-.343-.137-.48-.16-.138-.389-.092-.571-.046-.252.046-4.092 2.606-11.566 7.657-1.097.754-2.08 1.12-2.972 1.097-.982-.023-2.857-.549-4.274-1.006C2.178 17.326.806 17.03.921 16.07c.068-.503.754-1.006 2.034-1.532"
      clipRule="evenodd"
    />
  </svg>
);

export default React.memo(TelegramIcon);
